import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type {
  BetterstartIntegrationDefinition,
  InstalledIntegrationManifest
} from '@cli-types/integration-engine/integrations.js'
import { flattenEnvKeys } from '@core-engine/installable/protocol/flatten-env-keys.js'
import { integrationFiles } from './integration-files.js'

export function buildInstalledIntegrationManifest({
  config,
  definition,
  writtenFiles,
  configured,
  previousManifest
}: {
  config: ResolvedBetterstartConfig
  definition: BetterstartIntegrationDefinition
  writtenFiles?: string[]
  configured: boolean
  previousManifest?: InstalledIntegrationManifest | null
}): InstalledIntegrationManifest {
  return {
    id: definition.id,
    version: definition.version,
    kind: definition.kind,
    ownedFiles:
      writtenFiles ??
      previousManifest?.ownedFiles ??
      definition.files.map((file) => integrationFiles.resolveProjectPath(config, file.outputPath)),
    envKeys: flattenEnvKeys(definition),
    packageDependencies: definition.packageDependencies,
    devDependencies: definition.devDependencies,
    configured,
    dependencies: definition.dependencies,
    conflicts: definition.conflicts,
    installedAt: previousManifest?.installedAt ?? new Date().toISOString()
  }
}
